import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { EditWorkoutVM } from '../view-models/workoutEdit.viewModel';

export const UnsavedChangesModal = ({
  isOpen,
  isSaving,
  onSave,
  onDiscard,
  onCancel,
}: EditWorkoutVM['unsavedChangesModal']) => (
  <Modal
    isOpen={isOpen}
    onClose={onCancel}
    title="Save changes"
    modalClassName="w-full md:w-[670px]"
    centerContent={true}
    hideCloseButton={isSaving}
    disableBackdropClick={isSaving}
  >
    <div className="flex flex-col gap-6">
      <Typography variant="body" size="large" fontWeight="normal">
        You have applied some changes in this workout. Do you want to save them?
      </Typography>
      <div className="flex gap-4 justify-center">
        <Button
          variant="text"
          color="neutral"
          onClick={onDiscard}
          disabled={isSaving}
          className="w-[220px]"
        >
          Continue without saving
        </Button>
        <Button
          color="neutral"
          onClick={onSave}
          loading={isSaving}
          disabled={isSaving}
          className="w-[200px]"
        >
          Save
        </Button>
      </div>
    </div>
  </Modal>
);
